import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=070dd45a&scoped=true&"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=070dd45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070dd45a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VImg,VProgressCircular,VRow})
